import React from "react";
import { Instagram, Music } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const instructors = [{
  name: "DJ Madame Velvet",
  role: "EDM ROCK",
  bio: "Independent EDM Artist, Creating Room shakening Beats, and Catchy Melodies, Located in Michigan",
  image: {
    src: "https://guiding-lionfish.10web.cloud/wp-content/uploads/2026/05/45C096CA-20D8-4460-8B2A-D617D7BA9BD0-2.png?v=7h7u3t48kx4",
    srcset: "https://guiding-lionfish.10web.cloud/wp-content/uploads/2026/05/45C096CA-20D8-4460-8B2A-D617D7BA9BD0.png?v=81qag4h1ct3-wvc-srcset",
    sizes: "https://guiding-lionfish.10web.cloud/wp-content/uploads/2026/05/45C096CA-20D8-4460-8B2A-D617D7BA9BD0.png?v=x8egx4i8z6m-wvc-sizes",
    alt: "Xenon Pulse - EDM Pop Artist"
  },
  socials: {
    instagram: "https://www.instagram.com/madamevelvetofficial/",
    soundcloud: "https://on.soundcloud.com/Ew2SdBblQppZsvniTW"
  }
}, {
  name: "Ethan Heaven",
  role: "EDM POP",
  bio: "Independent EDM Artist combining the Spunky and Wild Beat of pop with the electronic vibe of EDM, Located in MIchigan",
  image: {
    src: "https://guiding-lionfish.10web.cloud/wp-content/uploads/2026/05/Ethan-Heaven-Artist-Picture.png?v=n1je69p6loi",
    srcset: "https://guiding-lionfish.10web.cloud/wp-content/uploads/2026/05/Ethan-Heaven-Artist-Picture.png?v=16bbh0488pt-wvc-srcset",
    sizes: "https://guiding-lionfish.10web.cloud/wp-content/uploads/2026/05/Ethan-Heaven-Artist-Picture.png?v=9n11abqy69i-wvc-sizes",
    alt: "Luna Vibe - EDM Rock Artist"
  },
  socials: {
    instagram: "https://www.instagram.com/ethanheavenmusic/",
    soundcloud: "https://on.soundcloud.com/eTmzqS6FFzYmyndwUk"
  }
}];
export default function TheSoundOfTheFuture() {
  return <section data-section-id="260146" id="the-sound-of-the-future" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center max-w-2xl mx-auto">
          <h2 className="font-default text-4xl md:text-6xl font-bold text-foreground mb-4 tracking-wider uppercase">
            The Sound of the Future
          </h2>
          <p className="text-muted-foreground text-xl font-default">Elevating independent artists beyond the horizon. Meet our fabulous artist shaping the next era of electronic and crossover music.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 justify-items-center mx-auto">
          {instructors.map((instructor, i) => <Card key={i} data-index={i} className="group overflow-hidden border-border/20 shadow-xl hover:shadow-primary/20 hover:bg-secondary/20 transition-all duration-500 bg-card/40 backdrop-blur-xl rounded-2xl flex flex-col items-center h-full hover:-rotate-1">
              <div className="relative w-full aspect-[3/4] overflow-hidden bg-muted">
                <img src={instructor.image.src} data-wvc-srcset={instructor.image.srcset} data-wvc-sizes={instructor.image.sizes} alt={instructor.image.alt} loading="lazy" className="w-full h-full object-cover transition-all duration-700 scale-100 group-hover:scale-110 mx-auto" />
                
                <div className="absolute top-4 left-1/2 -translate-x-1/2 z-10">
                  <span className="bg-secondary text-secondary-foreground text-[10px] font-bold px-3 py-1 rounded-md uppercase tracking-widest whitespace-nowrap shadow-lg">
                    {instructor.role}
                  </span>
                </div>

                <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 flex flex-col items-center justify-end pb-8 gap-4">
                  <div className="flex gap-3">
                    {instructor.socials.instagram && <Button variant="secondary" size="icon" asChild className="rounded-lg hover:bg-primary hover:text-primary-foreground transition-all shadow-lg">
                        <Link to={instructor.socials.instagram} newTab aria-label={`${instructor.name}'s Instagram`}>
                          <Instagram className="w-5 h-5" />
                        </Link>
                      </Button>}
                    {instructor.socials.soundcloud && <Button variant="secondary" size="icon" asChild className="rounded-lg hover:bg-primary hover:text-primary-foreground transition-all shadow-lg">
                        <Link to={instructor.socials.soundcloud} newTab aria-label={`${instructor.name}'s SoundCloud`}>
                          <Music className="w-5 h-5" />
                        </Link>
                      </Button>}
                  </div>
                  <Link to="/ArtistsPage" className="text-secondary font-default font-bold text-sm uppercase tracking-widest translate-y-4 group-hover:translate-y-0 transition-transform duration-500 drop-shadow-[0_0_8px_rgba(255,0,255,0.8)]">
                    View Profile
                  </Link>
                </div>
              </div>

              <CardContent className="p-6 text-center flex-grow flex flex-col justify-center border-t border-border/10">
                <h3 className="font-default text-2xl font-bold text-foreground mb-1 tracking-tight">
                  {instructor.name}
                </h3>
                <p className="text-muted-foreground text-sm mb-2">
                  Contact: info@heavenshorizons.com
                </p>
                <p className="text-primary font-medium text-xs uppercase tracking-[0.2em] mb-3">
                  Label Artist
                </p>
                <p className="text-muted-foreground text-sm leading-relaxed font-default opacity-80">
                  {instructor.bio}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}